import _TWOCOL from './TWOCOL';
import _ONECOL from './ONECOL';
import _THREECOL from './THREECOL';
import _INTERACTIVE from './INTERACTIVE';

export const TWOCOL = _TWOCOL;
export const ONECOL = _ONECOL;
export const THREECOL = _THREECOL;
export const TABBED = _INTERACTIVE;